import type {SignCode, SignDef} from './types'

export const SIGNS: Readonly<Record<SignCode, SignDef>> = {
    '521': {
        code: '521',
        label: '521-522 / Apdzīvota vieta',
        lvsRefs: ['9.19', '9.20'],
        minSize: {w: 1000, h: 400},
        defaults: {
            rows: [{text: 'RĪGA', h: 150, variant: 'A'}],
            bgColor: 'blue',
            strike: false,
            outerWidth: 1000,
            outerHeight: 400
        },
        steps: [
            {kind: 'content'},
            {kind: 'size'},
            {kind: 'background', allowBgColors: ['white', 'blue'], allowStrike: true},
            {kind: 'preview'},
            {kind: 'export'}
        ]
    },
    '705': {
        code: '705',
        label: '705 / Virziena rādītājs',
        lvsRefs: ['9.26'],
        minSize: {w: 800, h: 300},
        defaults: {
            rows: [{text: 'RĒZEKNE', h: 150, variant: 'A'}],
            bgColor: 'blue',
            strike: false,
            outerWidth: 800,
            outerHeight: 300,
            arrowDirection: 'left'
        },
        steps: [
            {kind: 'content'},
            {kind: 'arrow'},
            {kind: 'size'},
            {kind: 'background', allowBgColors: ['white', 'blue'], allowStrike: false},
            {kind: 'preview'},
            {kind: 'export'}
        ]
    }
}

export const SIGN_CODES: readonly SignCode[] = Object.keys(SIGNS) as SignCode[]
